<script>
  import { Steps } from 'element-ui'
  export default {
    name:'ElSteps',
    extends:Steps
  }
</script>
